//@ts-nocheck
/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export class BuiltinExportSchemas {
    static MAP: { [key: string]: string; } = {"__Builtin":"","__BuiltinFormData":"Form Data Only"};
}
